<template>
  <v-btn
    :block="full"
    :color="resolvedColor"
    :rounded="rounded"
    :outlined="outlined"
    :type="submit ? 'submit' : 'button'"
    :text="flat"
    :icon="icon"
    :disabled="disabled"
    @click="onClick"
    class="formButton"
    :to="to"
    :loading="loading"
  >
    <div
      :class="perigoIconWrapClass"
      style="display: flex; align-items: center;"
    >
      <v-icon v-if="beforeIcon" size="14px" style="margin-right:5px;">{{
        beforeIcon
      }}</v-icon>

      <span v-if="text" style="height: 14px;">{{ text }}</span>
      <slot></slot>

      <v-icon v-if="afterIcon" size="14px" style="margin-left:5px;">{{
        afterIcon
      }}</v-icon>
    </div>
  </v-btn>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FormButton",
  props: {
    text: {
      type: String,
      default: "",
      required: false
    },
    submit: {
      type: Boolean,
      default: false,
      required: false
    },
    full: {
      type: Boolean,
      default: false,
      required: false
    },
    flat: {
      type: Boolean,
      default: false,
      required: false
    },
    outlined: {
      type: Boolean,
      default: false,
      required: false
    },
    rounded: {
      type: Boolean,
      default: true,
      required: false
    },
    icon: {
      type: Boolean,
      default: false,
      required: false
    },
    type: {
      type: String,
      default: "primario",
      required: false
    },
    color: {
      type: String,
      default: "",
      required: false
    },
    beforeIcon: {
      type: String,
      default: "",
      required: false
    },
    afterIcon: {
      type: String,
      default: "",
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      requited: false
    },
    to: {
      type: String,
      default: undefined,
      requited: false
    },
    loading: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    ...mapGetters(["darkEnabled"]),
    resolvedColor() {
      if (this.outlined) {
        return this.color || this.type;
      }
      return this.type;
    },
    perigoIconWrapClass() {
      if (this.type !== "perigo") {
        return null;
      }
      return this.darkEnabled && !this.outlined
        ? "white--text"
        : this.outlined
        ? "red--text"
        : null;
    }
  },
  methods: {
    onClick(e) {
      this.$emit("click", e);
    }
  }
};
</script>
